/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TutorOfferController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, TutorOfferResponse, TutorOfferDto } from "../models";

@Injectable({ providedIn: "root" })
export class TutorOfferControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getOffer(id: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<TutorOfferResponse>;
    getOffer(id: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TutorOfferResponse>>;
    getOffer(id: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TutorOfferResponse>>;
    getOffer(id: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateOffer(id: string, tutorOfferDto: TutorOfferDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<TutorOfferResponse>;
    updateOffer(id: string, tutorOfferDto: TutorOfferDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TutorOfferResponse>>;
    updateOffer(id: string, tutorOfferDto: TutorOfferDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TutorOfferResponse>>;
    updateOffer(id: string, tutorOfferDto: TutorOfferDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: tutorOfferDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    setActive(id: string, active: boolean, observe?: 'body', options?: RequestOptions<'json'>): Observable<TutorOfferResponse>;
    setActive(id: string, active: boolean, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TutorOfferResponse>>;
    setActive(id: string, active: boolean, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TutorOfferResponse>>;
    setActive(id: string, active: boolean, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers/${id}`;

        let params = new HttpParams();
        if (active != null) {
            params = HttpParamsBuilder.addToHttpParams(params, active, 'active');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    createOffer(tutorOfferDto: TutorOfferDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<TutorOfferResponse>;
    createOffer(tutorOfferDto: TutorOfferDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TutorOfferResponse>>;
    createOffer(tutorOfferDto: TutorOfferDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TutorOfferResponse>>;
    createOffer(tutorOfferDto: TutorOfferDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: tutorOfferDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findOffersByTuteur(tuteurId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TutorOfferResponse>>;
    findOffersByTuteur(tuteurId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TutorOfferResponse>>>;
    findOffersByTuteur(tuteurId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TutorOfferResponse>>>;
    findOffersByTuteur(tuteurId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers/tuteur/${tuteurId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findActiveOffers(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TutorOfferResponse>>;
    findActiveOffers(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TutorOfferResponse>>>;
    findActiveOffers(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TutorOfferResponse>>>;
    findActiveOffers(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/offers/active`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
